/** Sign-in, one-time codes, password reset and two-step verification screens. */
export const auth = {
    brand: {
        tagline: "Run your shop online and offline from one place.",
        points: {
            offline: "A POS that keeps selling without the internet and syncs when it is back.",
            stock: "One stock across the website, phone orders and every branch.",
            channels: "Orders, couriers, customers and accounts in one system.",
        },
        footer: "Built for businesses in Bangladesh.",
    },
    signIn: {
        title: "Sign in",
        identifier: "Email or mobile number",
        password: "Password",
        submit: "Sign in",
        withOtp: "Sign in with an SMS code",
        forgot: "Forgot password?",
    },
    otp: {
        title: "Sign in with an SMS code",
        phone: "Mobile number",
        send: "Send code",
        code: "6-digit code",
        verify: "Verify and sign in",
        sent: "If this number has an account, we have sent it a code.",
        resend: "Send a new code",
        withPassword: "Sign in with a password",
    },
    totp: {
        title: "Two-step verification",
        body: "Enter the 6-digit code from your authenticator app, or one of your recovery codes.",
        code: "Code",
        submit: "Verify",
    },
    forgot: {
        title: "Reset your password",
        body: "Enter your email or mobile number. We'll send you a reset link or a code.",
        identifier: "Email or mobile number",
        submit: "Send",
        sent: "If an account exists, we have sent instructions to it.",
    },
    reset: {
        title: "Choose a new password",
        phone: "Mobile number",
        code: "6-digit code",
        password: "New password",
        confirm: "Confirm new password",
        mismatch: "The passwords don't match.",
        submit: "Set new password",
        done: "Your password has been changed. Please sign in.",
    },
    signedOut: "You have been signed out.",
    signUp: {
        title: "Create your business account",
        intro: "Free trial, no payment needed. Your shop and your online orders in one place.",
        phone: "Your mobile number",
        sendCode: "Send code",
        codeSent: "We sent a 6-digit code to {{phone}}.",
        changePhone: "Use another number",
        emailFirst: "Your email",
        codeSentEmail: "We sent a 6-digit code to {{email}}. Check your inbox and spam folder.",
        changeEmail: "Use another email",
        resend: "Send a new code",
        code: "6-digit code",
        businessName: "Business name",
        businessType: "How do you sell?",
        businessTypes: { online: "Online only", offline: "In my shop only", both: "Online and in my shop" },
        plannedBranches: "Number of branches",
        ownerName: "Your name",
        email: "Email",
        password: "Password",
        passwordHint: "At least 8 characters.",
        accept: "I accept the Terms of Service and the Privacy Policy.",
        read: "Read them:",
        mustAccept: "Accept the Terms of Service and the Privacy Policy to continue.",
        submit: "Create my business",
        haveAccount: "Already have an account? Sign in",
        noAccount: "New here? Create a business account",
        unavailable: "New business accounts can't be opened here.",
    },
    legal: {
        title: "We updated our terms",
        body: "Please read and accept the new version to keep using Sobthik.",
        accept: "Accept and continue",
    },
};
//# sourceMappingURL=auth.js.map